/**
 * The progress bar counts phases, not screens, so its total never changes mid-flow: the conditional
 * screens share their phase's segment — addons and wheel pickup count as services, insurance info and
 * login as summary. The mobile-vs-stationary choice comes before either flow and is not counted.
 */
const MOBILE_BOOKING_PHASES = ['address', 'car', 'services', 'time', 'summary'] as const;
const STATIONARY_BOOKING_PHASES = ['car', 'services', 'time', 'summary'] as const;

type MobileBookingPhase = (typeof MOBILE_BOOKING_PHASES)[number];
type StationaryBookingPhase = (typeof STATIONARY_BOOKING_PHASES)[number];

export type BookingFlowProgress = { current: number; total: number };

export const getMobileBookingProgress = (phase: MobileBookingPhase): BookingFlowProgress => ({
  current: MOBILE_BOOKING_PHASES.indexOf(phase) + 1,
  total: MOBILE_BOOKING_PHASES.length
});

export const getStationaryBookingProgress = (phase: StationaryBookingPhase): BookingFlowProgress => ({
  current: STATIONARY_BOOKING_PHASES.indexOf(phase) + 1,
  total: STATIONARY_BOOKING_PHASES.length
});
